module.exports = __webpack_public_path__ + "static/media/image10.3ea95490.png";